<template>
  <el-dialog
    :title="$t('EmailRows_Languages_DialogTitle')"
    :visible="visible"
    width="640px"
    append-to-body
    @close="close"
  >
    <el-table
      v-loading="loading"
      :data="rows"
      empty-text=""
      class="languages-table"
    >
      <el-table-column
        prop="language"
        :label="$t('EmailRows_Table_Language')"
        min-width="120"
      >
        <template v-slot="scope">
          {{ languageLabel(scope.row.language) }}
        </template>
      </el-table-column>

      <el-table-column
        prop="subject"
        :label="$t('EmailRows_Table_EmailSubject')"
        min-width="220"
        show-overflow-tooltip
      />

      <el-table-column
        prop="version"
        :label="$t('EmailRows_Table_SyncedVersion')"
        min-width="80"
      />

      <el-table-column
        prop="is_stale"
        :label="$t('EmailRows_Table_SyncStatus')"
        min-width="120"
      >
        <template v-slot="scope">
          <el-tag
            :type="scope.row.is_stale ? 'warning' : 'success'"
            size="small"
          >
            {{
              scope.row.is_stale
                ? $t('EmailRows_Table_SyncStatus_Stale')
                : $t('EmailRows_SyncStatus_InSync')
            }}
          </el-tag>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
import { projectEndpoint } from '@/core/helpers'
import RestApi from '@/core/services/RestApi'
import { languages } from '@/modules/campaign-manage/enum/LanguagesEnum'

export default {
  name: 'SyncedRowLanguagesDialog',

  props: {
    visible: {
      type: Boolean,
      default: false
    },
    contentId: {
      type: Number,
      required: true
    },
    actionId: {
      type: Number,
      default: null
    }
  },

  data() {
    return {
      loading: false,
      rows: []
    }
  },

  watch: {
    visible(open) {
      if (open && this.actionId) {
        this.fetchLanguages()
      } else if (!open) {
        this.rows = []
      }
    }
  },

  methods: {
    languageLabel(code) {
      return languages[code] || code || ''
    },

    close() {
      this.$emit('update:visible', false)
    },

    async fetchLanguages() {
      this.loading = true
      try {
        const endpoint = projectEndpoint({
          method: 'get',
          url: `content/${this.contentId}/usage-action/${this.actionId}/languages`
        })
        const response = await RestApi(endpoint)
        this.rows = response.data || []
      } catch (error) {
        this.$message.error(this.$t('EmailRows_Languages_FetchError'))
        this.rows = []
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.languages-table {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/modules/email-saved-rows/components/SyncedRowLanguagesDialog.vue